import React from 'react';

type FieldRowProps = {
  label: string;
  children: React.ReactNode;
  required?: boolean;
};

export const FieldRow: React.FC<FieldRowProps> = ({ label, children, required = false }) => (
  <div className="row mb-3 align-items-center">
    <label className="col-md-3 col-form-label text-md-end">
      {label}{required && ' *'}
    </label>
    <div className="col-md-9">{children}</div>
  </div>
);
